import apiSlice from './ApiSlice';

export const DashboardServiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET Finance Summary
    getFinanceSummary: builder.query({
      providesTags: ["dashboard"],
      query: (body) => {
        return {
          url: "/expence/get-finance-summary/",
          method: "POST",
          body,
        };
      },
    }),

    // GET Finance Summary
    getAllFinanceSummary: builder.query({
      providesTags: ["dashboard"],
      query: (body) => {
        return {
          url: "/expence/monthly-finance-summary",
          method: "POST",
          body,
        };
      },
    }),
    getDashboardGoals: builder.query({
      providesTags: ["dashboard"],
      query: () => {
        return {
          url: "/dashboard/goals",
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetFinanceSummaryQuery, useGetDashboardGoalsQuery, useGetAllFinanceSummaryQuery } = DashboardServiceApi;